export*from"./augmentation.js";
//# sourceMappingURL=index.js.map
